import { render, staticRenderFns } from "./HMSwitchTab.vue?vue&type=template&id=456a2857&scoped=true&"
import script from "./HMSwitchTab.vue?vue&type=script&lang=js&"
export * from "./HMSwitchTab.vue?vue&type=script&lang=js&"
import style0 from "./HMSwitchTab.vue?vue&type=style&index=0&id=456a2857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a2857",
  null
  
)

export default component.exports